export default __webpack_public_path__ + "static/media/Group39686.7f420476.png";